module.exports = __webpack_public_path__ + "img/J4.1381b1cf.webp";